module.exports = __webpack_public_path__ + "static/1-2b225eb6179d1ba3181cbc4e656e675b.png";